import { useQuery } from '@tanstack/react-query';
import { loadChatHistory } from '../../store/chatHistoryStore';
import { createHttpRequestError } from '../../utils/chatNetworkErrors';

const CO_PILOT_EXECUTION_HISTORY_QUERY_KEY = 'co-pilot-execution-history';

export const useCoPilotExecutionHistory = ({
  threadId,
  refetchInterval,
}: {
  threadId: string;
  refetchInterval?: number | false;
}) => {
  const result = useQuery({
    queryKey: [CO_PILOT_EXECUTION_HISTORY_QUERY_KEY, threadId],
    queryFn: async () => {
      if (!threadId) {
        return null;
      }
      const data = await loadChatHistory({ threadId });
      if (data === null) {
        throw createHttpRequestError({
          message: 'Chat history not found',
          statusCode: 404,
        });
      }
      return data;
    },
    enabled: Boolean(threadId),
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchInterval: refetchInterval ?? false,
  });

  return {
    history: result.data?.history ?? [],
    isLoading: result.isLoading,
    error: result.error,
    refetch: result.refetch,
  };
};
